module.exports = __webpack_public_path__ + "media/images/web/home/index/specs/user-6beba0a20e0bfce2df967409a9d846e4.svg";